export default __webpack_public_path__ + "static/media/sp-icon.7185fc0f.svg";